module.exports = __webpack_public_path__ + "img/welcomebg.2f90ff1c.jpg";